import React from 'react';
import {Typography, Grid} from '@mui/material';
import {ClientCardProps} from '../../../types/types';
import AurProfilePicture from '../../common/aur-profile-picture/AurProfilePicture';
import AurAnimatedCard from '../../common/aur-animated-card/AurAnimatedCard';
import {t} from 'i18next';

const AurClientCard: React.FC<ClientCardProps> = ({name, clientCode, type}) => {
  return (
    <AurAnimatedCard>
      <Grid container className="top-grid-container">
        <Grid item xs={3}>
          <AurProfilePicture
            displayText={name.split('')[0]}
            iconSize={56}
            textSize="ClientMedium"
            borderRadius={1}
            iconType="Client"
            backgroundImage={true}
          />
        </Grid>
        <Grid item xs={6} className="client-name">
          <Typography className="typo-text headline3_size">{name}</Typography>
        </Grid>
      </Grid>

      <Grid className="bottom-grid-container" container spacing={1}>
        <Grid item xs={12}>
          <Typography className="typo-text body3_size client-property-key">
            {t('clientDetails.clientId')}:{' '}
            <span className="client-property-value">{clientCode}</span>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className="typo-text body3_size client-property-key">
            {t('clientDetails.clientType')}:{' '}
            <span className="client-property-value">{type}</span>
          </Typography>
        </Grid>
      </Grid>
    </AurAnimatedCard>
  );
};

export default AurClientCard;
